var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg2VideoNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#5B6673;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1184,448h-88c-4.4,0-8,3.6-8,8v48c0,4.4,3.6,8,8,8h56v64h-56c-4.4,0-8,3.6-8,8v48c0,4.4,3.6,8,8,8h56v128 h-56c-4.4,0-8,3.6-8,8v48c0,4.4,3.6,8,8,8h56v128h-128v-56c0-4.4-3.6-8-8-8h-48c-4.4,0-8,3.6-8,8v184H512V904c0-4.4-3.6-8-8-8h-48 c-4.4,0-8,3.6-8,8v56H320v-56c0-4.4-3.6-8-8-8h-48c-4.4,0-8,3.6-8,8v216c0,17.7,14.3,32,32,32h896c17.7,0,32-14.3,32-32V480 C1216,462.3,1201.7,448,1184,448z M320,1024h128v64H320V1024z M1152,1088h-128v-64h128V1088z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M992,128H96c-17.7,0-32,14.3-32,32v640c0,17.7,14.3,32,32,32h896c17.7,0,32-14.3,32-32V160 C1024,142.3,1009.7,128,992,128z M128,768V600.7l255.4-255.4l222.2,222.2l49.8,49.8L806.1,768H128z M960,768h-63.4L725.8,597.2 L960,530.3V768z M676,547.4l-270-270c-12.5-12.5-32.8-12.5-45.3,0c0,0,0,0,0,0L128,510.2V192h832v274.3L676,547.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2VideoNormal);
export default __webpack_public_path__ + "static/media/img2video_normal.425834030ce814d5cbdd5c013b7b6ddf.svg";
export { ForwardRef as ReactComponent };